module.exports = __webpack_public_path__ + "static/media/tufts.b68e2c84.jpg";